// extracted by mini-css-extract-plugin
export default {"backdrop":"style_backdrop__ZbqJM","host":"style_host__ze1zy","frame":"style_frame__YTyCi"};